import React from "react";

function Footer() {
    return (
        <div className="rr">
            <style>{"\
            .rr{\
            text-align:center;\
            padding:5px;\
            margin-top:135px;\
            }\
      "}</style>
            <h6>&#169; Rewriter Tools! 2021</h6>
        </div>
    );
}

export default Footer;